module.exports = __webpack_public_path__ + "img/calendar.b4f88002.png";